export default class ClearCurrentAgentProfileErrors {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.currentAgent.clearErrors();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_agent/clear_current_agent_profile_errors.js